import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningCoursesBuilder(apiClient: AxiosInstance) {
  return async function getLearningCourses(): Promise<
    ILearning.LearningFilterMenuItem[] | null
  > {
    try {
      const response = await apiClient.get("/learning/api/courses/");
      return response.data.results;
    } catch {
      return null;
    }
  };
}
